<template>
  <div class="row">
    <v-flex lg4 md12 sm12 xs12>
        <v-card flat>
          <h4 class="earth-color">Update Booking Ban</h4>
          <v-container>
            <v-form @submit.prevent="saveBookingBanUpdate()">
              <v-text-field
                v-model="updated.first_name"
                label="First Name"
                persistent-hint
              ></v-text-field>
              <v-text-field
                v-model="updated.last_name"
                label="Last Name"
                persistent-hint
              ></v-text-field>

              <v-text-field
                v-model="updated.email_address"
                label="Email Address"
                persistent-hint
              ></v-text-field>

              <v-text-field
                v-model="updated.phone_number"
                label="Phone Number"
                persistent-hint
              ></v-text-field>

              <v-text-field
                v-model="updated.vehicle_registration"
                label="Vehicle Registration"
                persistent-hint
              ></v-text-field>

              <v-text-field
                v-model="updated.booking_ban_start_date"
                label="Ban Start Date"
                readonly
                persistent-hint
              ></v-text-field>

              <v-text-field
                v-model="updated.booking_ban_end_date"
                label="Ban End Date"
                readonly
                persistent-hint
              ></v-text-field>
              <v-text-field
                v-if="updated.increase_days == 0 && updated.status == false"
                label="Reduce Ban Period By "
                type="number"
                v-model="updated.reduce_days"
                suffix="Days"
                @input="reduceEndDays"
              ></v-text-field>
              <v-text-field
                v-else
                label="Reduce Ban Period By "
                type="number"
                v-model="updated.reduce_days"
                suffix="Days"
                @input="reduceEndDays"
                readonly
                :disabled="true"
              ></v-text-field>
              <!-- <v-text-field
                v-if="updated.reduce_days > 0"
                v-model="updated.new_reduce_end_date"
              ></v-text-field> -->

              <v-text-field
                v-if="updated.reduce_days == 0 || updated.reduce_days == null && updated.status == false"
                label="Increase Ban Period By "
                type="number"
                v-model="updated.increase_days"
                suffix="Days"
                @input="increaseEndDays"
              ></v-text-field>

              <v-text-field
                v-else
                label="Increase Ban Period By "
                type="number"
                v-model="updated.increase_days"
                suffix="Days"
                @input="increaseEndDays"
                readonly
                :disabled="true"
              ></v-text-field>

              <!-- <v-text-field
                v-if="updated.increase_days > 0 "
                label="New End Date "
                v-model="updated.new_increase_end_date"
                :disabled="true"
              ></v-text-field> -->

              <v-switch
                v-if="(updated.reduce_days == 0  || updated.reduce_days == null)&& updated.increase_days == 0"
                label="Lift Ban"
                color="primary"
                v-model="updated.status"
                required
              ></v-switch>

              <v-switch
                v-else
                label="Lift Ban"
                color="primary"
                v-model="updated.status"
                required
                readonly
                :disabled="true"
              ></v-switch>

              <v-btn
                :depressed="true"
                color="primary"
                block
                type="submit"
                :loading="$loadingTrue"
                >Update</v-btn
              >
            </v-form>

            <v-container>
              <v-btn
                :depressed="true"
                fab
                round
                small
                @click="back()"
                color="primary"
                ><v-icon>navigate_before</v-icon></v-btn
              >
            </v-container>
          </v-container>
        </v-card>
    </v-flex>
    <v-flex lg8 md12 sm12 xs12>
      <h4 class="earth-color">BAN HISTORY</h4>
      <v-data-table
        :headers="columns"
        :items="getBookingBan"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
      >
        <v-progress-linear
          slot="progress"
          color="primary"
          indeterminate
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="fancy">
            {{ props.item.first_name }} {{ props.item.last_name }}
          </td>
          <td class="fancy">{{ props.item.email_address }}</td>
          <td class="fancy">{{ props.item.phone_number }}</td>
          <td class="fancy">
            {{ formated_date(props.item.booking_ban_start_date) }}
            <b> TO </b> {{ formated_date(props.item.booking_ban_end_date) }}
          </td>

          <td class="fancy">{{ props.item.status }}</td>
          <td>{{ formated_date(props.item.created_at) }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-flex>
  </div>
</template>

<script>
export default {
  name: "view-update-alert",
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
      search: "",
      ranger_note: 0,
      columns: [
        {
          text: "Name",
          value: "first_name",
        },
        {
          text: "Email",
          value: "email_address",
        },
        {
          text: "Phone Number",
          value: "phone_number",
        },

        {
          text: "Ban Period",
          value: "booking_ban_start_date",
        },

        {
          text: "Ban status",
          value: "status",
        },
        {
          text: "Created",
          value: "created_at",
        },
      ],
      updated: {
        first_name: "",
        last_name: "",
        email_address: "",
        phone_number: "",
        vehicle_registration: "",
        booking_ban_start_date: "",
        booking_ban_end_date: "",
        status: false,
        increase_days: 0,
        reduce_days: 0,
        new_increase_end_date: "",
        new_reduce_end_date: "",
        booking_ban_id: "",
      },
    };
  },
  created() {
    this.$store.dispatch(
      "get_booking_ban",
      this.$route.params.booking_ban_id
    );
  },
  computed: {
    getBookingBan: function () {
      let single_booking_ban = this.$store.state.BookingStore.booking_ban;
      if (single_booking_ban.length > 0) {
        let single_booking_ban_obj = single_booking_ban[0];
        this.updated.first_name = single_booking_ban_obj.first_name;
        this.updated.last_name = single_booking_ban_obj.last_name;
        this.updated.email_address = single_booking_ban_obj.email_address;
        this.updated.phone_number = single_booking_ban_obj.phone_number;
        this.updated.booking_ban_id =
          single_booking_ban_obj.booking_ban_public_id;
        this.updated.vehicle_registration =
          single_booking_ban_obj.vehicle_registration;
        this.updated.booking_ban_start_date = this.$moment(
          single_booking_ban_obj.booking_ban_start_date
        ).format("YYYY-MM-DD");
        this.updated.booking_ban_end_date = this.$moment(
          single_booking_ban_obj.booking_ban_end_date
        ).format("YYYY-MM-DD");
        let status = single_booking_ban_obj.status;
        if (status == "1") {
          this.updated.status = false;
        } else {
          this.updated.status = true;
        }

        return this.$store.state.BookingStore.booking_ban[0].other_bans;
      }
    },
  },
  methods: {
    saveBookingBanUpdate: function () {
      this.$store.dispatch("update_booking_ban", this.updated);
    },
    back: function () {
      return this.$router.back();
    },
    increaseEndDays: function () {
      let end_date = this.updated.booking_ban_end_date;
      let num_days = this.updated.increase_days;
      this.updated.new_increase_end_date = this.$moment(end_date)
        .add(num_days, "days")
        .format("YYYY-MM-DD");
      return;
    },
    reduceEndDays: function () {
      let end_date = this.updated.booking_ban_end_date;
      let num_days = this.updated.reduce_days;
      let end_day = this.$moment(end_date)
        .subtract(num_days, "days")
        .format("YYYY-MM-DD");
      if (end_day <= this.updated.booking_ban_start_date) {
        alert("End date is less than start date");
        this.updated.reduce_days = null;
        this.updated.increase_days = 0;
      } else {
        this.updated.new_reduce_end_date = end_day;
      }
      // return;
    },
  },
};
</script>

<style scoped>
</style>
